import { onScroll, scrollTop } from './utils/scroll';
import { onReady } from './utils/onReady';
import { setupNav } from './components/nav';
import { setupLazyLoading } from './utils/lazyImage';
import { initVhUnitOverwrite, isTouchDevice, isIE11 } from './utils/helpers';
import { setupEventtickers } from './components/eventticker';
import { setupVideos } from './components/video';
import { setupStripe } from './utils/stripe';
import { setupVue } from './components/vue';

function init() {
    document.body.classList.remove('standby');

    if (isTouchDevice()) {
        document.body.classList.add('js-is-touch');
    }

    if (isIE11) {
        document.body.classList.add('js-ie-11');
    }

    setupVue();
    setupNav('.nav');

    onReady(() => {
        initVhUnitOverwrite();
        setupLazyLoading();
        setupEventtickers();
        setupVideos();

        const checkStripe = setInterval(() => {
            if (window.Stripe) {
                console.log('stripe loaded');
                clearInterval(checkStripe);
                setupStripe();
            }
        }, 10);
    });

    let prevScroll = 0;
    const header = document.querySelector('.header');

    if (header) {
        onScroll(() => {
            if (scrollTop > prevScroll && scrollTop > header.offsetHeight) {
                document.body.classList.add('js-scrolled');
            } else {
                document.body.classList.remove('js-scrolled');
            }

            prevScroll = scrollTop;
        });
    }
}

init();
